export enum Locale {
  en = 'en',
  my = 'my',
}
